import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { useCustWhOptionsQuery } from "hooks/useQueryHook";
import { useState } from "react";
import { SelectField } from "ui-components/Form";

import { FormTitle, Text, DatePickerField } from "ui-components/Form";

function StockAttributesInfo({ formRender, control, errors, customerCode, setValue }) {
  const [warehouseCodeOptions, setWarehouseCodeOptions] = useState([]);

  useCustWhOptionsQuery({
    customerCode,
    onSuccess: (data) => {
      setWarehouseCodeOptions(data.data.data);
      //setValue warehouse first option
      if (data.data.data)
      setValue("warehouseCode", data.data.data[0]);
    },
  });

  function renderFn(property, index, length) {
    const { xs, disabled, edit, ...data } = property;
    //custom xs
    const xs2 = xs ? xs : 12 / length;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
    };

    let renderField;
    if (data.type === "text" || data.type === "number") {
      renderField = <Text field={fieldProps} />;
    } else if (data.type === "date") {
      renderField = <DatePickerField field={fieldProps} />;
    } else if (data.type === "select") {
      renderField = (
        <SelectField
          field={fieldProps}
          options={
            (data.name === "warehouseCode" && warehouseCodeOptions)
          }
          control={control}
          errors={errors}
        />
      );
    }
    return (
      <Grid key={index} item xs={xs2}>
        {renderField}
      </Grid>
    );
  }

  return (
    <MDBox>
      <FormTitle title={"Edit Stock Attributes"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default StockAttributesInfo;
